export default "__VITE_ASSET__DvBJoSgY__"